import axios from "axios";
import Config from "./../../config/index";
import RefreshTokenHandler from "./refresh-token";

/**
 *
 * @param email
 * @param folio_no
 * @param account_name
 * @param account_no
 * @param bank_name
 * @param client_name
 * @param balance_update
 * @param cnic
 * @param mobile
 * @param city
 * @param registration_date
 * @param account_title
 * @param nature
 * @param branch_name
 * @param amc_name
 * @param client_code
 * @param type
 * @param ntn
 * @param address
 * @param country
 */
const addUnitHolder = async (
  email: string,
  amc_code: string,
  folio_no: string,
  account_no: string,
  bank_name: string,
  balance_unit: string,
  cnic: string,
  mobile: string,
  city: string,
  account_title: string,
  branch_name: string,
  amc_name: string,
  ntn: string,
  address: string,
  name: string,
  main_folio_no: string,
  phone: string,
  cnic_expiry: string,
  reinvest: string,
  client_email: string,
  father_spouse: string,
  tax_exempt: string,
  zakat_exempt: string,
  type: string,
  guardian_name: string,
  guardian_relation: string,
  guardian_cnic: string,
  nominee_name: string,
  nominee_relation: string,
  nominee_cnic: string,
  joint_h_1_name: string,
  joint_h_1_father_spouse: string,
  joint_h_1_cnic: string,
  joint_h_2_name: string,
  joint_h_2_father_spouse: string,
  joint_h_2_cnic: string,
  joint_h_3_name: string,
  joint_h_3_father_spouse: string,
  joint_h_3_cnic: string,
  portfolio_management: string,
  // filer: string,
  province: string,
  tax_status: string,
  joint_h1_tax_status: string,
  joint_h2_tax_status: string,
  joint_h3_tax_status: string,
  cdc_ias: string,
  cdc_sub_account: string,
  cdc_participant_id: string,
  in_house_sale: string = "false",
  sales_company: string = "",
  sales_person: string = "",
  investor_id: string = "",
  risk_factor: string = "",
  dob: string = "",
  age: string = "",
  profile_picture: string = "",
  systematic_investment?: any,
  unitholder_Type: string = "",
  lifetime_cnic?: string,
  joining_date?: string,
  employee_nominee?: any
) => {
  const url = `${Config.baseUrl}/unit-holder/`;
  const formData = new FormData();
  const dataOBJ = {
    email,
    amc_code,
    folio_no,
    account_no,
    bank_name,
    balance_unit,
    cnic,
    mobile,
    city,
    account_title,
    branch_name,
    amc_name,
    ntn,
    address,
    name,
    main_folio_no,
    phone,
    cnic_expiry,
    reinvest,
    client_email,
    father_spouse,
    tax_exempt,
    zakat_exempt,
    type,
    guardian_name,
    guardian_relation,
    guardian_cnic,
    nominee_name,
    nominee_relation,
    nominee_cnic,
    joint_h_1_name,
    joint_h_1_father_spouse,
    joint_h_1_cnic,
    joint_h_2_name,
    joint_h_2_father_spouse,
    joint_h_2_cnic,
    joint_h_3_name,
    joint_h_3_father_spouse,
    joint_h_3_cnic,
    portfolio_management,
    // filer: ,
    province,
    tax_status,
    joint_h1_tax_status,
    joint_h2_tax_status,
    joint_h3_tax_status,
    cdc_ias,
    cdc_sub_account,
    cdc_participant_id,
    in_house_sale,
    sales_company,
    sales_person,
    investor_id,
    risk_factor,
    dob,
    age,
    profile_picture,
    systematic_investment,
    unitholder_Type,
    lifetime_cnic,
    joining_date,
    employee_nominee,
  };
  let keys = Object.keys(dataOBJ);
  for (let i = 0; i < keys.length; i++) {
    let temp = keys[i];
    if (
      typeof dataOBJ[temp] == "object" &&
      temp !== "zakat_exempt_document_file" &&
      temp !== "joint_h_1_cnic_file" &&
      temp !== "joint_h_1_ntn_document_file" &&
      temp !== "joint_h_1_passport_copy_file" &&
      temp !== "joint_h_1_address_bill_copy_file" &&
      temp !== "joint_h_1_pay_slip_file" &&
      temp !== "joint_h_1_employment_letter_file" &&
      temp !== "joint_h_2_cnic_file" &&
      temp !== "joint_h_2_ntn_document_file" &&
      temp !== "joint_h_2_passport_copy_file" &&
      temp !== "joint_h_2_address_bill_copy_file" &&
      temp !== "joint_h_2_pay_slip_file" &&
      temp !== "joint_h_2_employment_letter_file" &&
      temp !== "joint_h_3_cnic_file" &&
      temp !== "joint_h_3_ntn_document_file" &&
      temp !== "joint_h_3_passport_copy_file" &&
      temp !== "joint_h_3_address_bill_copy_file" &&
      temp !== "joint_h_3_pay_slip_file" &&
      temp !== "joint_h_3_employment_letter_file" &&
      temp !== "cnic_copy_file" &&
      temp !== "ntn_verification_file" &&
      temp !== "passport_copy_file" &&
      temp !== "address_bill_file" &&
      temp !== "pay_slip_file" &&
      temp !== "employment_letter_file" &&
      temp !== "registration_certificate_file" &&
      temp !== "account_opening_request_file" &&
      temp !== "registered_business_address_evidence_file" &&
      temp !== "all_partners_documents_file" &&
      temp !== "partnership_deed_file" &&
      temp !== "partnership_registeration_document_file" &&
      temp !== "partnership_authority_letter_file" &&
      temp !== "certified_llp_agreement_file" &&
      temp !== "llp_form_5_file" &&
      temp !== "llp_form_3_file" &&
      temp !== "llp_authority_letter_file" &&
      temp !== "board_resolution_copy_file" &&
      temp !== "memorendum_articles_file" &&
      temp !== "certified_form_a_file" &&
      temp !== "certified_form_29_file" &&
      temp !== "certified_form_b_file" &&
      temp !== "certified_form_2_file" &&
      temp !== "certified_form_c_file" &&
      temp !== "all_director_documents_file" &&
      temp !== "all_beneficial_documents_file" &&
      temp !== "board_of_investment_letter_file" &&
      temp !== "signatories_passport_documents_file" &&
      temp !== "list_of_directors_file" &&
      temp !== "certified_form_3_file" &&
      temp !== "authorization_letter_file" &&
      temp !== "certificate_of_registration_file" &&
      temp !== "by_laws_regulations_file" &&
      temp !== "resolutions_file" &&
      temp !== "annual_accounts_documents_file" &&
      temp !== "power_of_attorney_file" &&
      temp !== "letter_administration_probate_file" &&
      temp !== "guardian_documents_file" &&
      temp !== "joint_h_1_cnic_back_copy_file" &&
      temp !== "joint_h_2_cnic_back_copy_file" &&
      temp !== "joint_h_3_cnic_back_copy_file" &&
      temp !== "cnic_back_copy_file" &&
      temp !== "signature_specimen_file" &&
      temp !== "undertaking_file"
    ) {
      if (temp === "profile_picture") {
        formData.append(temp, dataOBJ[temp]);
      } else {
        formData.append(temp, JSON.stringify(dataOBJ[temp]));
      }
    } else {
      formData.append(temp, dataOBJ[temp]);
    }
  }
  try {
    const result: any = await axios.post(url, formData, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addUnitHolder(
          email,
          amc_code,
          folio_no,
          account_no,
          bank_name,
          balance_unit,
          cnic,
          mobile,
          city,
          account_title,
          branch_name,
          amc_name,
          ntn,
          address,
          name,
          main_folio_no,
          phone,
          cnic_expiry,
          reinvest,
          client_email,
          father_spouse,
          tax_exempt,
          zakat_exempt,
          type,
          guardian_name,
          guardian_relation,
          guardian_cnic,
          nominee_name,
          nominee_relation,
          nominee_cnic,
          joint_h_1_name,
          joint_h_1_father_spouse,
          joint_h_1_cnic,
          joint_h_2_name,
          joint_h_2_father_spouse,
          joint_h_2_cnic,
          joint_h_3_name,
          joint_h_3_father_spouse,
          joint_h_3_cnic,
          portfolio_management,
          // filer,
          province,
          tax_status,
          joint_h1_tax_status,
          joint_h2_tax_status,
          joint_h3_tax_status,
          cdc_ias,
          cdc_sub_account,
          cdc_participant_id,
          in_house_sale,
          sales_company,
          sales_person,
          investor_id,
          risk_factor,
          dob,
          age,
          profile_picture,
          systematic_investment,
          unitholder_Type,
          lifetime_cnic,
          joining_date,
          employee_nominee
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getAllUnitHolders = async (
  email: string,
  page_number: string | number = "",
  page_size: string | number = "",
  options?: {
    search_value?: string;
    type?: string;
    company_code?: string;
    no_amc?: string;
    [key: string]: string | undefined;
  }
) => {
  const url = `${Config.baseUrl}/unit-holder?email=${email}&page_number=${page_number}&page_size=${page_size}`;
  try {
    const params: any = {};
    const { search_value, type, company_code, no_amc } = options || {};
    if (type) params.unitholder_type = type;
    if (search_value) params.search_value = search_value;
    if (company_code) params.company_code = company_code;
    if (no_amc) params.no_amc = no_amc;

    const result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllUnitHolders(email, page_number, page_size, options);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getAllUnitHoldersByAmc = async (
  email: string,
  amc_code: string,
  unitholder_type: string = "",
  company_code?: string
) => {
  const url = `${Config.baseUrl}/unit-holder/by-amc?email=${email}&amc_code=${amc_code}&unitholder_type=${unitholder_type}`;
  try {
    const params: any = {};
    if (company_code) params.company_code = company_code;
    const result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllUnitHoldersByAmc(email, amc_code, unitholder_type);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param folio_no
 * @param status
 */
const updateUnitHolderStatus = async (
  email: string,
  folio_no: string,
  status: string
) => {
  const url = `${Config.baseUrl}/unit-holder?email=${email}&folio_no=${folio_no}&status=${status}`;
  try {
    const result: any = await axios.put(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateUnitHolderStatus(email, folio_no, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getAllUnitHolderByFolioNo = async (email: string, folioNo: string) => {
  const url = `${Config.baseUrl}/unit-holder/by-folio?email=${email}&folio_no=${folioNo}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllUnitHolderByFolioNo(email, folioNo);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 *
 * @param search_value
 */
const searchUnitHolderAPI = async (email: string, search_value: string) => {
  const url = `${Config.baseUrl}/unit-holder?email=${email}&search_value=${search_value}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await searchUnitHolderAPI(email, search_value);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const searchUnitHolderAPIModified = async (email: string) => {
  const url = `${Config.baseUrl}/unit-holder?email=${email}&search_value=`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await searchUnitHolderAPIModified(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const uploadUnitHolder = async (email: string, dataObj: any) => {
  const url = `${Config.baseUrl}/unit-holder/bulk-upload`;
  try {
    let data = JSON.stringify(dataObj);
    const result: any = await axios.post(
      url,
      { email, data },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await uploadUnitHolder(email, dataObj);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const uploadUnitHolding = async (email: string, dataObj: any) => {
  const url = `${Config.baseUrl}/unit-holder/update-unit-holding`;
  try {
    let data = JSON.stringify(dataObj);
    const result: any = await axios.post(
      url,
      { email, data },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await uploadUnitHolding(email, dataObj);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const bulkUploadUnitHolderFile = async (
  email: string,
  amc_code: string,
  dataObj: any,
  company_code?: string
) => {
  const url = `${Config.baseUrl}/unit-holder/bulk-upload-unit-holders`;
  try {
    let data = JSON.stringify(dataObj);
    const result: any = await axios.post(
      url,
      { email, amc_code, data, company_code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (
      err.response.data.status === 401 ||
      err.response.status === 403 ||
      err.response.statusCode === 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await bulkUploadUnitHolderFile(
          email,
          amc_code,
          dataObj,
          company_code
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const editUnitHolder = async (
  email: string,
  folio_no: string,
  account_no: string,
  bank_name: string,
  balance_unit: string,
  cnic: string,
  mobile: string,
  city: string,
  account_title: string,
  branch_name: string,
  amc_name: string,
  ntn: string,
  address: string,
  name: string,
  main_folio_no: string,
  phone: string,
  cnic_expiry: string,
  reinvest: string,
  client_email: string,
  father_spouse: string,
  tax_exempt: string,
  zakat_exempt: string,
  type: string,
  guardian_name: string,
  guardian_relation: string,
  guardian_cnic: string,
  nominee_name: string,
  nominee_relation: string,
  nominee_cnic: string,
  joint_h_1_name: string,
  joint_h_1_father_spouse: string,
  joint_h_1_cnic: string,
  joint_h_2_name: string,
  joint_h_2_father_spouse: string,
  joint_h_2_cnic: string,
  joint_h_3_name: string,
  joint_h_3_father_spouse: string,
  joint_h_3_cnic: string,
  portfolio_management: string,
  // filer: string,
  province: string,
  tax_status: string,
  joint_h1_tax_status: string,
  joint_h2_tax_status: string,
  joint_h3_tax_status: string,
  cdc_ias: string,
  cdc_sub_account: string,
  cdc_participant_id: string,
  in_house_sale: string = "false",
  sales_company: string = "",
  sales_person: string = "",
  risk_factor: string = "",
  dob: string = "",
  age: string = "",
  profile_picture: string = "",
  systematic_investment?: any,
  unitholder_Type: string = "",
  lifetime_cnic?: string,
  joining_date?: string,
  employee_nominee?: any,
  leaving_date?: string
) => {
  const url = `${Config.baseUrl}/unit-holder/update`;
  const formData = new FormData();
  const dataOBJ = {
    email,
    folio_no,
    account_no,
    bank_name,
    balance_unit,
    cnic,
    mobile,
    city,
    account_title,
    branch_name,
    amc_name,
    ntn,
    address,
    name,
    main_folio_no,
    phone,
    cnic_expiry,
    reinvest,
    client_email,
    father_spouse,
    tax_exempt,
    zakat_exempt,
    type,
    guardian_name,
    guardian_relation,
    guardian_cnic,
    nominee_name,
    nominee_relation,
    nominee_cnic,
    joint_h_1_name,
    joint_h_1_father_spouse,
    joint_h_1_cnic,
    joint_h_2_name,
    joint_h_2_father_spouse,
    joint_h_2_cnic,
    joint_h_3_name,
    joint_h_3_father_spouse,
    joint_h_3_cnic,
    portfolio_management,
    province,
    tax_status,
    joint_h1_tax_status,
    joint_h2_tax_status,
    joint_h3_tax_status,
    cdc_ias,
    cdc_sub_account,
    cdc_participant_id,
    in_house_sale,
    sales_company,
    sales_person,
    risk_factor,
    dob,
    age,
    profile_picture,
    systematic_investment,
    unitholder_Type,
    lifetime_cnic,
    joining_date,
    employee_nominee,
    leaving_date,
  };
  let keys = Object.keys(dataOBJ);
  for (let i = 0; i < keys.length; i++) {
    let temp = keys[i];
    if (
      typeof dataOBJ[temp] == "object" &&
      temp !== "zakat_exempt_document_file" &&
      temp !== "joint_h_1_cnic_file" &&
      temp !== "joint_h_1_ntn_document_file" &&
      temp !== "joint_h_1_passport_copy_file" &&
      temp !== "joint_h_1_address_bill_copy_file" &&
      temp !== "joint_h_1_pay_slip_file" &&
      temp !== "joint_h_1_employment_letter_file" &&
      temp !== "joint_h_2_cnic_file" &&
      temp !== "joint_h_2_ntn_document_file" &&
      temp !== "joint_h_2_passport_copy_file" &&
      temp !== "joint_h_2_address_bill_copy_file" &&
      temp !== "joint_h_2_pay_slip_file" &&
      temp !== "joint_h_2_employment_letter_file" &&
      temp !== "joint_h_3_cnic_file" &&
      temp !== "joint_h_3_ntn_document_file" &&
      temp !== "joint_h_3_passport_copy_file" &&
      temp !== "joint_h_3_address_bill_copy_file" &&
      temp !== "joint_h_3_pay_slip_file" &&
      temp !== "joint_h_3_employment_letter_file" &&
      temp !== "cnic_copy_file" &&
      temp !== "ntn_verification_file" &&
      temp !== "passport_copy_file" &&
      temp !== "address_bill_file" &&
      temp !== "pay_slip_file" &&
      temp !== "employment_letter_file" &&
      temp !== "registration_certificate_file" &&
      temp !== "account_opening_request_file" &&
      temp !== "registered_business_address_evidence_file" &&
      temp !== "all_partners_documents_file" &&
      temp !== "partnership_deed_file" &&
      temp !== "partnership_registeration_document_file" &&
      temp !== "partnership_authority_letter_file" &&
      temp !== "certified_llp_agreement_file" &&
      temp !== "llp_form_5_file" &&
      temp !== "llp_form_3_file" &&
      temp !== "llp_authority_letter_file" &&
      temp !== "board_resolution_copy_file" &&
      temp !== "memorendum_articles_file" &&
      temp !== "certified_form_a_file" &&
      temp !== "certified_form_29_file" &&
      temp !== "certified_form_b_file" &&
      temp !== "certified_form_2_file" &&
      temp !== "certified_form_c_file" &&
      temp !== "all_director_documents_file" &&
      temp !== "all_beneficial_documents_file" &&
      temp !== "board_of_investment_letter_file" &&
      temp !== "signatories_passport_documents_file" &&
      temp !== "list_of_directors_file" &&
      temp !== "certified_form_3_file" &&
      temp !== "authorization_letter_file" &&
      temp !== "certificate_of_registration_file" &&
      temp !== "by_laws_regulations_file" &&
      temp !== "resolutions_file" &&
      temp !== "annual_accounts_documents_file" &&
      temp !== "power_of_attorney_file" &&
      temp !== "letter_administration_probate_file" &&
      temp !== "guardian_documents_file" &&
      temp !== "joint_h_1_cnic_back_copy_file" &&
      temp !== "joint_h_2_cnic_back_copy_file" &&
      temp !== "joint_h_3_cnic_back_copy_file" &&
      temp !== "cnic_back_copy_file" &&
      temp !== "signature_specimen_file" &&
      temp !== "undertaking_file"
    ) {
      if (temp === "profile_picture") {
        formData.append(temp, dataOBJ[temp]);
      } else {
        formData.append(temp, JSON.stringify(dataOBJ[temp]));
      }
    } else {
      formData.append(temp, dataOBJ[temp]);
    }
  }
  try {
    const result: any = await axios.post(url, formData, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await editUnitHolder(
          email,
          folio_no,
          account_no,
          bank_name,
          balance_unit,
          cnic,
          mobile,
          city,
          account_title,
          branch_name,
          amc_name,
          ntn,
          address,
          name,
          main_folio_no,
          phone,
          cnic_expiry,
          reinvest,
          client_email,
          father_spouse,
          tax_exempt,
          zakat_exempt,
          type,
          guardian_name,
          guardian_relation,
          guardian_cnic,
          nominee_name,
          nominee_relation,
          nominee_cnic,
          joint_h_1_name,
          joint_h_1_father_spouse,
          joint_h_1_cnic,
          joint_h_2_name,
          joint_h_2_father_spouse,
          joint_h_2_cnic,
          joint_h_3_name,
          joint_h_3_father_spouse,
          joint_h_3_cnic,
          portfolio_management,
          /*filer*/ province,
          tax_status,
          joint_h1_tax_status,
          joint_h2_tax_status,
          joint_h3_tax_status,
          cdc_ias,
          cdc_sub_account,
          cdc_participant_id,
          in_house_sale,
          sales_company,
          sales_person,
          dob,
          age,
          profile_picture,
          systematic_investment,
          unitholder_Type,
          lifetime_cnic,
          joining_date,
          employee_nominee,
          leaving_date
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getUnitHoldersByAmcAndFolioNo = async (
  email: string,
  amc_code: string,
  folio_no,
  no_amc: string = ""
) => {
  const url = `${Config.baseUrl}/unit-holder/by-amc-code-and-folio-no?email=${email}&amc_code=${amc_code}&folio_no=${folio_no}`;
  const params: any = {};
  if (no_amc) params.no_amc = no_amc;
  try {
    const result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getUnitHoldersByAmcAndFolioNo(
          email,
          amc_code,
          folio_no,
          no_amc
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const uploadMultipleUnitHolding = async (
  email: string,
  dataObj: any,
  approve: string
) => {
  const url = `${Config.baseUrl}/unit-holder/update-unit-holding-multiple`;
  try {
    let data = JSON.stringify(dataObj);
    const result: any = await axios.post(
      url,
      { email, data, approve },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (
      err.response.data.status === 401 ||
      err.response.status === 403 ||
      err.response.statusCode === 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await uploadMultipleUnitHolding(email, dataObj, approve);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getAllUnitHoldersByCompany = async ({
  email,
  company_code,
  folio_no,
  search,
}: {
  email: string;
  company_code?: string;
  folio_no?: string;
  search?: any;
}) => {
  const url = `${Config.baseUrl}/unit-holder/by-company`;
  try {
    const params: any = { email };
    if (company_code) params.company_code = company_code;
    if (search) params.search = search;
    if (folio_no) params.folio_no = folio_no;
    const result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status === 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllUnitHoldersByCompany({
          email,
          company_code,
          folio_no,
          search,
        });
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export {
  getAllUnitHoldersByAmc,
  addUnitHolder,
  editUnitHolder,
  getAllUnitHolders,
  getAllUnitHolderByFolioNo,
  searchUnitHolderAPI,
  uploadUnitHolder,
  uploadUnitHolding,
  updateUnitHolderStatus,
  searchUnitHolderAPIModified,
  getUnitHoldersByAmcAndFolioNo,
  bulkUploadUnitHolderFile,
  uploadMultipleUnitHolding,
  getAllUnitHoldersByCompany,
};
